import { DateTime } from 'luxon'

export const notEmpty = <T>(value: T | null | undefined): value is T => {
  return value !== null && value !== undefined
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- lint-debt
export const parseBool = (value: any, defaultIfNotSet = false) => {
  if (value === true || value === 'true') {
    return true
  }
  if (typeof value === 'number' && value > 0) {
    return true
  }
  if (value === false || value === 'false') {
    return false
  }
  return defaultIfNotSet
}

export const uniqueArrayOfEntities = <T extends { id: string }>(array: T[]): T[] => {
  return array.filter((entity, index, self) => index === self.findIndex((item) => item.id === entity.id))
}

export const PLAIN_DATE_FORMAT_LUXON = 'yyyy-MM-dd' //
/**
 *
 * Returns plain date as string. It removes time and timezone component and it doesn't do any conversion.
 * @param {Date} date
 * @return {string} Plain date as string. Ex: 2023-05-01
 */
export const getPlainDate = (date: Date): string => {
  return DateTime.fromJSDate(date).toFormat(PLAIN_DATE_FORMAT_LUXON)
}
